import './map.scss';
import GoogleMapsLoader from '../../utilities/js/google-maps-loader';

class Map {
    constructor(element, options) {
        const settings = {
            initAttr: 'data-map',
            map: {
                zoom: 15,
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                styles: [
                    {
                        'featureType': 'landscape.man_made',
                        'elementType': 'geometry.fill',
                        'stylers': [
                            {
                                'color': '#dadada'
                            }
                        ]
                    },
                    {
                        'featureType': 'landscape.man_made',
                        'elementType': 'labels',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'landscape.natural',
                        'elementType': 'geometry.fill',
                        'stylers': [
                            {
                                'color': '#c8e3dc'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.attraction',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.business',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.government',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.medical',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.park',
                        'elementType': 'geometry.fill',
                        'stylers': [
                            {
                                'color': '#c8e3dc'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.place_of_worship',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.school',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi.sports_complex',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'geometry.fill',
                        'stylers': [
                            {
                                'color': '#8498a5'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'geometry.stroke',
                        'stylers': [
                            {
                                'color': '#2d4351'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'geometry.fill',
                        'stylers': [
                            {
                                'color': '#b0c6d0'
                            }
                        ]
                    }
                ]
            }
        };

        this.settings = Object.assign({}, settings, options);

        this.$map = element;
        this.destination = this.$map.getAttribute(this.settings.initAttr);
    }

    initialize() {

        const ZoomControl = (controlDiv) => {
            const controlWrapper = document.createElement('div');

            controlWrapper.classList.add('map__controls');
            controlDiv.appendChild(controlWrapper);

            const zoomInButton = document.createElement('div');
            zoomInButton.classList.add('map__zoom-in');
            controlWrapper.appendChild(zoomInButton);

            const zoomOutButton = document.createElement('div');
            zoomOutButton.classList.add('map__zoom-out');
            controlWrapper.appendChild(zoomOutButton);

            google.maps.event.addDomListener(zoomInButton, 'click', () => {
                this.map.setZoom(this.map.getZoom() + 1);
            });

            google.maps.event.addDomListener(zoomOutButton, 'click', () => {
                this.map.setZoom(this.map.getZoom() - 1);
            });
        };

        this.map = new google.maps.Map(this.$map, this.settings.map);

        const zoomControlDiv = document.createElement('div');
        new ZoomControl(zoomControlDiv);

        zoomControlDiv.index = 1;
        this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlDiv);

        this.convertAddressToLocation(this.destination)
            .then((location) => {
                this.centerMap(location);
                this.setMarker(location);
            })
            .catch((status) => {
                console.warn('no location found');
                console.warn(status);
                this.centerMap({ lat: 53.863740, lng: 10.684550 });
            });
    }

    centerMap(location) {
        this.map.setCenter(location);
    }

    setMarker(location) {
        const image = {
            scaledSize: new google.maps.Size(43, 56),
            url: '/assets_website/images/marker.svg'
        };
        new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: location,
            icon: image
        });
    }

    convertAddressToLocation(destination) {
        return new Promise((res, rej) => {

            new google.maps.Geocoder().geocode({ 'address': destination, 'componentRestrictions': { 'country': 'DE' } }, (results, status) => {
                if(status == 'OK') {
                    const location = results[0].geometry.location;
                    res(location);
                } else {
                    rej(status);
                }
            });
        });
    }
}

export { Map };

let googleMapsLoaded = false;

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const context = eventDetails.$context;

    const waitForConsent = setInterval(() => {
        if (typeof CookieConsent !== 'undefined') {
            const $$map = context.querySelectorAll('[data-map]');

            if (CookieConsent.consent.statistics === true) { // eslint-disable-line
                if (context && !googleMapsLoaded) {
                    GoogleMapsLoader.loadGoogleMaps().then(() => {
                        for (let i = 0; i < $$map.length; i++) {
                            const $map = $$map[i];
                            const $mapAPI = new Map($map);
                            $mapAPI.initialize();
                        }

                        // Set the flag to indicate that Google Maps API has been loaded
                        googleMapsLoaded = true;
                    });

                    if ($$map.length > 0) {
                        $$map.forEach((map) => {
                            const $placeholder = map.parentElement.querySelector('.media__restriction');

                            if ($placeholder) {
                                $placeholder.remove();
                            }
                        });
                    }
                    clearInterval(waitForConsent);
                }
            } else {
                if ($$map.length > 0) {
                    $$map.forEach((map) => {
                        const $placeholder = map.parentElement.querySelector('.media__restriction');

                        if ($placeholder) {
                            $placeholder.classList.add('is--shown');
                            $placeholder.closest('[data-map]')?.classList.add('has--restriction');
                        }
                    });
                }
            }
        }
        else {
            console.log('waiting for CookieContent');
        }
    }, 300);
});
